import { motion } from "framer-motion";
import { HiArrowRight, HiCheckCircle, HiClock, HiSparkles } from "react-icons/hi";
import { slideIn } from "../utils/motion";

function ServiceCard({ title, description, timeline, outcome, features }) {
  return (
    <motion.article
      variants={slideIn}
      className="glass group relative flex h-full flex-col overflow-hidden rounded-xl p-6 shadow-glass transition duration-300 hover:-translate-y-1 hover:shadow-neon"
    >
      <div className="pointer-events-none absolute inset-0 opacity-0 transition duration-300 group-hover:opacity-100">
        <div className="absolute inset-x-0 -top-12 h-24 bg-cyan-300/20 blur-2xl" />
      </div>

      <div className="relative mb-5 flex items-start justify-between gap-4">
        <div>
          <h3 className="text-xl font-semibold text-white">{title}</h3>
          <p className="mt-3 text-sm leading-relaxed text-blue-100/80">{description}</p>
        </div>
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-cyan-200/20 bg-cyan-300/10 text-cyan-200">
          <HiSparkles className="h-5 w-5" />
        </div>
      </div>

      <div className="relative grid gap-3 sm:grid-cols-2">
        <div className="rounded-lg border border-white/10 bg-black/25 p-3">
          <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-cyan-300">
            <HiClock className="h-4 w-4" />
            Timeline
          </div>
          <p className="mt-2 text-sm font-semibold text-white">{timeline}</p>
        </div>
        <div className="rounded-lg border border-white/10 bg-black/25 p-3">
          <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-cyan-300">
            <HiArrowRight className="h-4 w-4" />
            Outcome
          </div>
          <p className="mt-2 text-sm font-semibold text-white">{outcome}</p>
        </div>
      </div>

      <div className="relative mt-5 space-y-3">
        {features.map((feature) => (
          <div key={feature} className="flex gap-3 text-sm leading-6 text-blue-100/82">
            <HiCheckCircle className="mt-1 h-5 w-5 shrink-0 text-cyan-300" />
            <span>{feature}</span>
          </div>
        ))}
      </div>

      <div className="relative mt-6 border-t border-white/10 pt-4">
        <a
          href="#contact"
          className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.14em] text-cyan-200 transition group-hover:text-white"
        >
          Discuss Service
          <HiArrowRight className="h-4 w-4 transition group-hover:translate-x-1" />
        </a>
      </div>
    </motion.article>
  );
}

export default ServiceCard;
